import React from "react";
import { Button, Link, Stack, Text } from "@wearewqa/wqa-design-system";

interface SignInFormActionsProps {
  isSubmitting: boolean;
}

export function SignInFormActions({ isSubmitting }: SignInFormActionsProps) {
  return (
    <Stack align="center">
      <Link underline="hover" href="forgotten-password">
        <Text size="textSm" weight="medium" color="brand.primary.700">
          Forgotten password
        </Text>
      </Link>
      <Button
        type="submit"
        label={"Sign in"}
        disabled={isSubmitting}
        fullWidth
      />
    </Stack>
  );
}
